import { announce } from '@react-aria/live-announcer';
import { useIntl } from 'react-intl';

import { useProgramFavorite } from '@/hooks/app/useProgramFavorite';
import heartIconFilled from 'icons/heart-filled.svg';
import heartIconOutline from 'icons/heart-outline.svg';

import messages from './messages';
import { Wrapper } from './styles';
import { FaveHeartProps } from './types';

const ProgramFavorite = ({ id, title, shouldShowText }: FaveHeartProps) => {
	const { formatMessage } = useIntl();

	const { isFaved, toggleFavorite } = useProgramFavorite(id);

	const onPress = async (): Promise<void> => {
		toggleFavorite();

		const messageToAnnounce = !isFaved ? messages.isFavedAnnouncement : messages.isUnfavedAnnouncement;
		announce(formatMessage(messageToAnnounce, { title }));
	};

	return (
		<Wrapper
			data-testid="fave-heart"
			aria-label={isFaved ? 'unmark as favorite' : 'mark as favorite'}
			aria-pressed={isFaved}
			onPress={onPress}
			$isFaved={isFaved}
			Icon={isFaved ? heartIconFilled : heartIconOutline}
		>
			{shouldShowText && formatMessage(messages.favoriteCTA)}
		</Wrapper>
	);
};

export default ProgramFavorite;
